import { Link, useParams } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { ArrowLeft } from 'lucide-react';
import RequestDetail from '@/components/requests/RequestDetail';
import { staffRequest } from '@/lib/requests';
import { useAuth } from '@/hooks/use-auth';

export default function RequestDetailPage() {
  const { id = '' } = useParams<{ id: string }>();
  const { user } = useAuth();
  const q = useQuery({ queryKey: ['client-request', id], queryFn: () => staffRequest(id), enabled: !!id, refetchInterval: 30000 });
  return (
    <div className="space-y-4 max-w-4xl">
      <Link to="/requests" className="inline-flex items-center gap-1.5 text-xs text-muted hover:text-accent-400 min-h-9">
        <ArrowLeft size={13} /> Client requests
      </Link>
      {q.isLoading && <div className="text-sm text-muted py-10 text-center">Loading...</div>}
      {q.isError && <div className="text-sm text-muted py-10 text-center">This request is not there, or not yours to see.</div>}
      {q.data && <RequestDetail r={q.data} portal={false} isAdmin={user?.role === 'owner' || user?.role === 'manager'} />}
    </div>
  );
}
